import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M18 9a1 1 0 0 0 -1 -1h-2a1 1 0 0 0 -1 1v6a1 1 0 0 0 1 1h2a1 1 0 0 0 1 -1v-2a1 1 0 0 0 -1 -1h-3","key":"svg-0"}],["path",{"d":"M6 8h4l-2 8","key":"svg-1"}]]

const IconNumber76Small = createReactComponent('outline', 'number-76-small', 'Number76Small', __iconNode);

export default IconNumber76Small;